import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("compte_admin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des SubCategories
export const listeDesSubCategorie = async (page, size, param) => {
  return await axios.get(
    `${BASE_URL}/parametrage/subCategorie/all?page=${page}&size=${size}&param=${param}`,
    {}
  );
};

// /liste SubCategories sans filters
export const listesubCategoriesSansFiltre = async () => {
  return await axios.get(
    `${BASE_URL}/parametrage/subCategorie/allSubCategorie`,
    {}
  );
};

// Enregiste des SubCategories
export const enregistrerSubCategories = async (dataSubCategories) => {
  return await axios.post(
    `${BASE_URL}/parametrage/subCategorie`,
    dataSubCategories
  );
};

// modifie subCategorie

export const modifierSubCategorieById = async (
  subCategorieId,
  dataSubCategorie
) => {
  return await axios.put(
    `${BASE_URL}/parametrage/subCategorie/${subCategorieId}`,
    dataSubCategorie
  );
};

// supprimer une categorie
export const supprimerSubCategorieById = async (subCategorieId) => {
  return await axios.delete(
    `${BASE_URL}/parametrage/subCategorie/${subCategorieId}`
  );
};
